<template>
    <div
        class="quote-container contact__location"
        :class="{'quote-container_with-photo': hasPhoto}"
    >
      <slot name="address" />
      <slot name="phone" />

      <AccordionComponent
          v-if="$slots.schedule"
          :title="openingHoursLabel"
          :border="'none'"
          class="contact__location_white-box">
        <slot name="schedule" />
      </AccordionComponent>
    </div>
</template>
<script>
import AccordionComponent from './common/Accordion';

export default {
  name: 'ContactLocationComponent',
  components: {
    AccordionComponent,
  },
  props: {
    hasPhoto: {
      type: Boolean,
      default: false,
    },
    openingHoursLabel: {
      type: String,
      default: 'Openingstijden',
    },
  },
};
</script>

<style scoped lang="scss">
</style>
